var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{staticClass:"z-aside hidden-xs-only",staticStyle:{"padding":"0"}},[_c('device-list')],1),_c('div',{staticClass:"hidden-sm-and-up"}),_c('el-main',{staticStyle:{"padding":"0"}},[_c('map-area')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }